<template>
  <div class="marcaVehiculo">
    <label :for="id">{{label}}</label>
    <select @change="marcaSeleccionada" class="pointer" v-model="marcaVehiculo" :name="id" :id="id">
      <option value="">Seleccione...</option>
      <option v-for="item in marcas" :value="item">{{item.nombre | upper}}</option>
    </select>
  </div>
</template>

<script>
  export default {
    name: "MarcaVehiculo",
    props: ["id", "label", "marcas", "index"],
    methods: {
      marcaSeleccionada() {
        this.$emit("marcaSeleccionada", {value: this.marcaVehiculo, index: this.index})
        this.$store.dispatch("producto/getModeloVehiculo", {
          index: this.index,
          data: this.marcaVehiculo
        })
      },
      clear(index) {
        this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "vehiculo", index, data: ""})
        this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "vehiculos", index, data: []})
        this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "modelo", index, data: ""})
        this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "modelos", index, data: []})
      }
    },
    computed: {
      marcaVehiculo: {
        get() {
          return this.$store.state.producto.producto.vehiculosCompatibles[this.index].marca
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {
            key: "marca",
            index: this.index,
            data: value
          })
          if (value === "") this.clear(this.index)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .marcaVehiculo {
    select {
      width: 100%;
    }
  }
</style>
